import {load} from '@shopify/theme-sections';
import 'preact/devtools';

// TEMPLATES
import './templates/collection.js';
import './templates/product.js';
import './templates/search.js';
import './templates/404.js';

// SECTIONS
import './sections/business-reviews.js';
import './sections/featured-collections.js';
import './sections/featured-reviews.js';
import './sections/header.js';
import './sections/hero-slider.js';
import './sections/image-text-cta.js';
import './sections/recommended-collection.js';
import './sections/spend-and-win.js';
import './sections/shop-by-category.js';
import './sections/trending-categories.js';
import './sections/trust.js';

// COMPONENTS
import initProductCards from './components/product-card';
import pdpSizeGuide from './components/pdp-size-guide';
import initDeliveryTimer from './components/delivery-timer';
import modelSelector from './components/model-selector.js';
import initCountdownTimer from './components/countdown-timer.js';

// REACT APPS
import '../app';

document.addEventListener('DOMContentLoaded', () => {
  load('*');
  initProductCards();
  initCountdownTimer();
  modelSelector();
  pdpSizeGuide();
  initDeliveryTimer();
});
